import React from 'react';
import {SignUpComponent} from '../../components';

const TAG = 'AgencySignUp';

export const AgencySignUp: React.FC = React.memo(() => {
  return <div>{`${TAG} - T.B.D: im ok`}</div>;
  return <SignUpComponent />;
});
